import {Component} from "@angular/core";
import {EmptySearchParamsFilterModel} from "../../../../shared/models/search/params/filters/empty-search-params-filter.model";
import {SearchResultsFilterModel} from "../../../../shared/models/search/results/filters/search-results-filter.model";
import {MediaResultItem} from "../../../models/search-results/items/media-result-item";
import {SearchTabDirective} from "../search-tab.directive";
import {ScopedSearchResultModel} from "../../../models/search-results/scoped-search-result.model";

@Component({
    selector: "pcg-ng-media-filter",
    template: require('./media-tab.component.html')
})
export class MediaTabComponent extends SearchTabDirective<EmptySearchParamsFilterModel, ScopedSearchResultModel<MediaResultItem, SearchResultsFilterModel>> {
}
